(function () {
    "use strict";

    angular
        .module("app")
        .directive("factorySearchHelp", ["SearchFactory", factorySearchHelp]);

    function factorySearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.factoryKey = "";
                        scope.factoryName = "";
                        scope.countryName = "";
                        scope.countryKey = "";
                        scope.factoryGroupKey = "";
                        scope.factoryGroupName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.factoryKey === scope.displayValue)) {

                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.factorySearch(function (factory) {
                        scope.factoryKey = factory ? factory.FactoryKey : "";
                        scope.factoryName = factory ? factory.FactoryName : "";
                        scope.countryName = factory ? factory.Country : "";
                        scope.countryKey = factory ? factory.CountryCode : "";
                        scope.factoryGroupKey = factory ? factory.FactoryGroupKey : "";
                        scope.factoryGroupName = factory ? factory.FactoryGroupName : "";

                        scope.displayValue = scope.factoryKey;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue, ""]);
                };

                scope.$watch("factoryKey", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.factoryKey;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: {
                factoryKey: "=", factoryName: "=", countryName: "=?", countryKey: "=?", factoryGroupKey: "=?", factoryGroupName: "=?",
                readOnly: "=", needToValidate: "=", setDirtyCallback: "&"
            },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

